import {
    type GetAllAccountDeletionRequestHistoriesResponseType,
    type GetAllAccountDeletionRequestHistoriesRequestType
} from "./type";
import {
    request
} from "../request";

const getAllAccountDeletionRequestHistories = async (
    params: GetAllAccountDeletionRequestHistoriesRequestType
): Promise<GetAllAccountDeletionRequestHistoriesResponseType> => {
    const searchParams = new URLSearchParams();

    if(params.source) {
        searchParams.append("source", params.source);
    }

    if(params.reason) {
        searchParams.append("reason", params.reason);
    }

    if(params.search) {
        searchParams.append("search", params.search);
    }

    if(params.page !== undefined) {
        searchParams.append("page", String(params.page));
    }

    const queryStr = searchParams.toString();
    const endpoint = queryStr ? `/request/getAllAccountDeletionRequestHistories?${queryStr}` : "/request/getAllAccountDeletionRequestHistories";

    return await request<GetAllAccountDeletionRequestHistoriesResponseType>(endpoint, {
        method: "GET"
    });
};
export default getAllAccountDeletionRequestHistories;
